import authHelper from 'src/api/auth/helper';

function Ctrl($rootScope, currentUser, keychain, trackingService) {
  $rootScope.currentUser = currentUser;

  if ($rootScope.currentUser) {
    authHelper.setAuthToken(keychain.getConsumerAuthToken());
  }

  if ($rootScope.currentUser) {
    trackingService.identify($rootScope.currentUser);
  }

  $rootScope.$on('login', () => {
    if ($rootScope.currentUser) {
      authHelper.setAuthToken(keychain.getConsumerAuthToken());
    }
  });
}

Ctrl.$inject = [
  '$rootScope',
  'currentUser',
  'jsSdk.keychain',
  'trackingService'
];

export default Ctrl;



// WEBPACK FOOTER //
// ./src/components/app/appCtrl.js